import './App.css';
import Navbar from './components/navbar';
import Footer from './components/footer';
import Home from './components/Home';
import Projects from './components/Projects';
import Contact from './components/Contact';
import { SpeedInsights } from "@vercel/speed-insights/react";
import Skills from './components/Skills';


function App() {
  return (
      <div>
        <Navbar />
        <div id="home">
          <Home />
        </div>
        <div id="skills">
          <Skills />
        </div>
        <div id="projects">
          <Projects />
        </div>
        <div id="contact">
          <Contact />
        </div>
        <SpeedInsights />
        <Footer />
      </div>
  );
}

export default App;
